import StoredAnalysis from 'domain/entity/storedAnalysis';
import { Result } from 'domain/types';
import { UpdateNameStoredAnalysisClient } from 'use-case/storedAnalysis/update/updateNameStoredAnalysisClient';
import UpdateNameStoredAnalysisCriteria from 'use-case/storedAnalysis/update/updateNameStoredAnalysisCriteria';

export type UpdateNameStoredAnalysisResult = Result<StoredAnalysis>;
export type UpdateNameStoredAnalysis = (criteria: UpdateNameStoredAnalysisCriteria) => Promise<UpdateNameStoredAnalysisResult>;

export const updateNameStoredAnalysisUseCase = (
    updateNameStoredAnalysisClient: UpdateNameStoredAnalysisClient
): UpdateNameStoredAnalysis => (criteria: UpdateNameStoredAnalysisCriteria): Promise<UpdateNameStoredAnalysisResult> =>
    updateNameStoredAnalysisClient(criteria);
